const description = [
  [
    {
      id: 1,
      description: "Feels brittle and loses moisture quickly"
    },
    {
      id: 2,
      description: "My hair is okay thanks"
    },
    {
      id: 3,
      description: "Oil just seems to sit on my hair"
    }
  ],
  [
    {
      id: 4,
      description: "Feels dry most of the time, can be itchy and flaky"
    },
    {
      id: 5,
      description: "My scalp is okay, I'm happy with it"
    },
    {
      id: 6,
      description: "Oil sits on my scalp, can get itchy sometimes"
    }
  ],
  [
    {
      id: 7,
      description: "Loose or defined 'S' pattern, less volume, can be frizzy"
    },
    {
      id: 8,
      description: "Defined loose to tight curls, thick with body"
    },
    {
      id: 9,
      description: "Tight kinks with less visible pattern unless close"
    }
  ]
];

// how to work with this data**
// console.log(description[0][2].description);

// const [OneOne, OneTwo, OneThree] = description[0];
// console.log(OneOne.description);
// console.log(OneTwo.description);
// console.log(OneThree.description);
// const [TwoOne, TwoTwo, TwoThree] = description[1];
// console.log(TwoOne.description);
// console.log(TwoTwo.description);
// console.log(TwoThree.description);
// const [ThreeOne, ThreeTwo, ThreeThree] = description[2];
// console.log(ThreeOne.description);
// console.log(ThreeTwo.description);
// console.log(ThreeThree.description);

export default description;
